import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';

import { LoadingCircularPanelService } from '../../../shared/components/loading-circular-panel/loading-circular-panel.service';
import { AnalyticAppName } from '../../constants/constants';
import { MonitorService } from '../monitor/monitor.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) { }

  handleError(error: any | HttpErrorResponse): void {
    const waitingPanelService = this.injector.get(LoadingCircularPanelService);
    waitingPanelService.toggleLoadingCircularPanelVisibility(false);
    const monitorError = new Error('Error catched by GlobalErrorHandler');
    monitorError.name = 'Error catched by GlobalErrorHandler';
    monitorError.message =
      !!error && !!error.message ? error.message : 'cannot log error message';
    monitorError.stack =
      !!error && !!error.stack ? error.stack : 'cannot log error stack';
    const monitorService = this.injector.get(MonitorService);
    monitorService.logError(
      {
        error: monitorError,
        properties: {
          name: AnalyticAppName,
          message: 'GlobalErrorHandler'
        }
      },
      {
        sendToAppInsight: true,
        sendToHeap: true
      }
    );
  }
}
